export const PointPromotionApiResult = {
    /** 성공 */
    SUCCESS: 'SUCCESS',
    /** 실패 */
    FAILED: 'FAILED',
    /** 프로모션 대상 상품 없음 */
    NO_PROMOTION_TARGET: 'NO_PROMOTION_TARGET',
    /** 적용가능한 프로모션 없음 */
    NO_APPLICABLE_PROMOTION: 'NO_APPLICABLE_PROMOTION',
} as const

export type PointPromotionApiResultValues = Constant<typeof PointPromotionApiResult>
